import { Component } from '@angular/core';

@Component({
    selector: 'app-nozzledisplacements-data',
    templateUrl: './nozzledisplacements-data.component.html',
    styleUrl: './nozzledisplacements-data.component.css',
    standalone: false
})
export class NozzledisplacementsDataComponent {

}
